module.exports = __webpack_public_path__ + "img/C-suite_wc.f44f5c04.svg";